import closeIcon from "../../assets/close-icon.png";
import { useLanguage, getSenderManagementTranslation } from '../../hooks/useLanguage';

export const AddorEditSender = ({ handleSubmit, handleChange, isEditing, closeModal, formData, isLoading }) => {
  const [isSpanish] = useLanguage();
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-999">
      <div className="bg-white p-8 rounded shadow-lg min-w-[650px]">
        <div className='flex justify-between items-center mb-4'>
          <h2 className='text-2xl font-bold'>{isEditing ? getSenderManagementTranslation('editSender', isSpanish) : getSenderManagementTranslation('addSender', isSpanish)}</h2>
          <img className='h-6 w-6 cursor-pointer' src={closeIcon} onClick={closeModal} alt="Close" />
        </div>
        <form onSubmit={handleSubmit}>
          <div className='flex flex-col'>
            <div className="form-group flex-1">
              <label htmlFor="name">{getSenderManagementTranslation('senderName', isSpanish)}</label>
              <input
                type="text"
                name="nombre"
                placeholder={getSenderManagementTranslation('senderName', isSpanish)}
                className="form-input border-container-force"
                value={formData.nombre}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group flex-1">
              <label htmlFor="tax_id">{getSenderManagementTranslation('senderTaxId', isSpanish)}</label>
              <input
                type="text"
                name="identificacion_fiscal"
                placeholder={getSenderManagementTranslation('senderTaxId', isSpanish)}
                className="form-input border-container-force"
                value={formData.identificacion_fiscal}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group flex-1">
              <label htmlFor="eori">{getSenderManagementTranslation('senderEori', isSpanish)}</label>
              <input
                type="text"
                name="eori"
                placeholder={getSenderManagementTranslation('senderEori', isSpanish)}
                className="form-input border-container-force"
                value={formData.eori}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group flex-1">
              <label htmlFor="address">{getSenderManagementTranslation('senderAddress', isSpanish)}</label>
              <input
                type="text"
                name="direccion"
                placeholder={getSenderManagementTranslation('senderAddress', isSpanish)}
                className="form-input border-container-force"
                value={formData.direccion}
                onChange={handleChange}
                required
              />
            </div>
            <div className='flex gap-4'>
              <div className="form-group flex-1">
                <label htmlFor="city">{getSenderManagementTranslation('senderCity', isSpanish)}</label>
                <input
                  type="text"
                  name="localidad"
                  placeholder={getSenderManagementTranslation('senderCity', isSpanish)}
                  className="form-input border-container-force"
                  value={formData.localidad}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group flex-1">
                <label htmlFor="country">{getSenderManagementTranslation('senderCountry', isSpanish)}</label>
                <input
                  type="text"
                  name="pais"
                  placeholder={getSenderManagementTranslation('senderCountry', isSpanish)}
                  className="form-input border-container-force"
                  value={formData.pais}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className='flex mt-4'>
              <button
                type="submit"
                className='border bg-default text-white rounded-full py-2 px-5 text-sm'
                disabled={isLoading}
              >
                {isLoading ? getSenderManagementTranslation('processing', isSpanish) : isEditing ? getSenderManagementTranslation('updateSender', isSpanish) : getSenderManagementTranslation('addSender', isSpanish)}
              </button>
              <button
                type="button"
                onClick={closeModal}
                className='rounded-md py-2 px-2 text-sm ml-2'
                disabled={isLoading}
              >
                {getSenderManagementTranslation('cancel', isSpanish)}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}